/*
 * This file was automatically generated. Do not make any changes
 * directly as they may be overwritten.
 *
 * To update this file, run `yarn run generate-api`.
 */
import { apiService } from "assets/scripts/domain/apiService";
/* tslint:disable */
export const CHANGE_URL = "/api/security/change";
export const FORGOT_PASSWORD_URL = "/api/security/forgotpassword";
export const QUESTIONS_URL = "/api/security/questions";
export const RESET_URL = "/api/security/reset";
export const SECURITY_QUESTION_URL = "/api/security/question";
export const VALIDATE_URL = "/api/security/validate";
export function change(model) {
    return apiService.post(CHANGE_URL, true, {
        model
    });
}
export function forgotPassword(model) {
    return apiService.post(FORGOT_PASSWORD_URL, false, {
        model
    });
}
export function questions() {
    return apiService.post(QUESTIONS_URL, false, {});
}
export function reset(model) {
    return apiService.post(RESET_URL, false, {
        model
    });
}
export function securityQuestion(model) {
    return apiService.post(SECURITY_QUESTION_URL, false, {
        model
    });
}
export function validate(password) {
    return apiService.post(VALIDATE_URL, false, {
        password
    });
}
/* tslint:enable */ 



// WEBPACK FOOTER //
// ./src/generated/api/security.ts